import React, { useState, useEffect } from 'react'
import { getRoute } from '@/Router/routes.config'
import './index.less'
import { RightOutlined, DownOutlined } from '@ant-design/icons'

const Slider = (props) => {
  let [menuList, setMenuList] = useState([])
  let [slideVisible, setSlideVisible] = useState(false)
  let [currentLevel, setCurrentLevel] = useState({})

  // 导航栏点击
  const changePage = (url) => {
    props.props.history.push({
      pathname: url,
    })
  }

  const storeCurrentLevel = (currentLevel) => {
    window.__React_current_route__ = currentLevel
    sessionStorage.setItem('__Route_Level__', JSON.stringify(currentLevel))
    setCurrentLevel(currentLevel)
  }

  useEffect(() => {
    const menu = getRoute(props.userType).tree
    menuList = menu
    setMenuList(menu)
  }, [props.userType])


  useEffect(() => {
    getActive()
  }, [props.props.location.pathname])

  const closeActive = () => {
    const s = JSON.stringify(menuList)
    const menu = s.replace(/"active":true/gim, '"active":false')
    return JSON.parse(menu)
  }

  // const setDefualOpen = (keys) => {
  //   const dep = (menu) => {
  //     menu.forEach((level) => {
  //       if (keys.includes(level.index)) {
  //         changeOpen('', level)
  //       }
  //       if (level.childrens && level.childrens.length > 0) {
  //         dep(level.childrens)
  //       }
  //     })
  //   }
  //   dep(menuList)
  // }

  // const getCurrentLevelKey = () => {
  //   const key = sessionStorage.getItem("__Route_key__")
  //   if(key) {
  //     return key
  //   } else {
  //     return ''
  //   }
  // }

  const getActive = () => {
    let find = false
    const dep = (menu) => {
      menu.forEach((level) => {
        const url = level.pathname.split(/:[a-zA-Z]+/)[0]
        if (level.childrens && level.childrens.length > 0) {
          dep(level.childrens)
          if (props.props.location.pathname.indexOf(url) > -1 && !find) {
            find = true
            level.url = level.pathname.match(/:[a-zA-Z]+/g) ? props.props.location.pathname : level.pathname
            storeCurrentLevel(level)
          }
        } else {
          if (props.props.location.pathname.indexOf(url) > -1 && !find) {
            find = true
            level.url = level.pathname.match(/:[a-zA-Z]+/g) ? props.props.location.pathname : level.pathname
            storeCurrentLevel(level)
          } else {
            // if(props.props.location.pathname === level.pathname) {
            //   storeCurrentLevel(level)
            // }
            // console.log(222222)
          }
        }
      })
    }
    dep(menuList)
  }

  const changeOpen = (e, item) => {
    const dep = (menu) => {
      return menu.map((level) => {
        if (level.childrens && level.childrens.length > 0) {
          if (level.childrens.every((r) => r.hidden === true) && level.index === item.index) {
            level.url = item.url ? item.url : item.pathname
            changePage(level.url)
          }
          level.childrens = dep(level.childrens)
        } else {
          if (level.index === item.index) {
            level.url = item.url ? item.url : item.pathname
            storeCurrentLevel(level)
            changePage(level.url)
          }
        }

        const k = item.index.split('-')
        const q = level.index.split('-')
        if (q.length === 1) {
          if (level.index === k[0]) {
            level.active = true
            if (level.index === item.index) {
              level.open = !level.open
            } else {
              level.open = true
            }
          }
        } else if (item.index.indexOf(level.index) > -1) {
          if(item.index === level.index) {
            level.active = true
            level.open = true
          } else {
            let a = item.index.split('-')
            let b = a.slice(0, a.length-1)
            if(b.join('-').indexOf(level.index) > -1) {
              level.active = true
              level.open = true
            }
          }
        } else {
          level.active = false
        }
        return level
      })
    }
    const menu = closeActive()
    const copy = JSON.parse(JSON.stringify(menu))
    const M = dep(copy)
    setMenuList(M)
  }

  const getMenuList = (menu) => {
    const Menu = menu.map((level, i) => {
      if (!level.hidden && level.childrens && level.childrens.length > 0) {
        return (
          <li key={i} className={level.active ? 'on' : ''}>
            <p
              onClick={(e) => {
                changeOpen(e, level)
              }}
            >
              {slideVisible ? (
                <span>
                  {level.icon ? <i className={level.icon}></i> : ''}
                  <span className="nm">{level.name}</span>
                  {level.childrens.some((r) => r.hidden === false) ? (
                    level.open ? (
                      <DownOutlined className="jt" />
                    ) : (
                      <RightOutlined className="jt" />
                    )
                  ) : (
                    ''
                  )}
                </span>
              ) : (
                <span>{level.icon ? <i className={level.icon}></i> : ''}</span>
              )}
            </p>
            {level.open && level.childrens.some((r) => r.hidden === false) ? (
              <ul className={'level' + (level.index.split('-').length + 1)}>{getMenuList(level.childrens)}</ul>
            ) : (
              ''
            )}
          </li>
        )
      } else {
        return level.hidden ? (
          ''
        ) : (
          <li
            key={i}
            onClick={(e) => {
              changeOpen(e, level)
            }}
            className={level.active ? 'on' : ''}
          >
            {slideVisible ? (
              <p>
                {level.icon ? <i className={level.icon}></i> : ''}
                <span className="nm">{level.name}</span>
              </p>
            ) : (
              <p>{level.icon ? <i className={level.icon}></i> : ''}</p>
            )}
          </li>
        )
      }
    })
    return Menu
  }

  const changeSlideVisible = () => {
    setSlideVisible(!slideVisible)
  }

  const mouseEnter = () => {
    setSlideVisible(true)
    if (Object.keys(currentLevel).length > 0) {
      changeOpen('', currentLevel)
    }
  }

  const mouseLeave = () => {
    setSlideVisible(false)
  }

  //   console.log(getMenuList(menuList), 'menuList')

  return (
    <div
      className={slideVisible ? 'slide-wrap open' : 'slide-wrap'}
      onMouseEnter={() => {
        mouseEnter()
      }}
      onMouseLeave={() => {
        mouseLeave()
      }}
    >
      <p
        className={slideVisible ? 'icon iconfont icon-shouqi zx' : 'icon iconfont icon-zhankai zx'}
        onClick={() => {
          changeSlideVisible()
        }}
      ></p>
      <div className="menu-list level1">{getMenuList(menuList)}</div>
    </div>
  )
}

export default Slider
